import { gameAudio } from '../audio/GameAudio';
import { attachMenuSounds } from './MenuSounds';

// Quick mute button for engine + SFX. Lives next to MusicToggle in the
// top-right corner; the music toggle handles the title theme separately.
export class AudioToggle {
  readonly root: HTMLButtonElement;

  constructor(parent: HTMLElement) {
    this.root = document.createElement('button');
    this.root.id = 'audio-toggle';
    this.root.className = 'tst-btn tst-btn-sm';
    this.root.type = 'button';
    this.root.title = 'Mute engine + SFX';

    this.root.addEventListener('click', () => {
      gameAudio.toggleMuted();
      this.refresh();
    });
    attachMenuSounds(this.root);

    this.refresh();
    parent.appendChild(this.root);
  }

  refresh(): void {
    const muted = gameAudio.isMuted();
    this.root.textContent = muted ? 'SFX Off' : 'SFX On';
    this.root.classList.toggle('tst-btn-ghost', muted);
  }
}
